import { useEffect } from "react";
import { AboutSection } from "./components/AboutSection";
import { ContactSection } from "./components/ContactSection";
import { ExperienceSection } from "./components/ExperienceSection";
import { Hero } from "./components/Hero";
import { ProjectsSection } from "./components/ProjectsSection";
import { SiteFooter } from "./components/SiteFooter";
import { SiteHeader } from "./components/SiteHeader";
import { SkillsSection } from "./components/SkillsSection";
import { scrollToSection } from "./lib/scrollToSection";

export default function App() {
  useCleanUrl();

  return (
    <>
      <a
        href="#main-content"
        className="bg-inverse text-on-inverse fixed top-3 left-3 z-[100] -translate-y-20 rounded-full px-4 py-2 text-sm font-semibold transition focus:translate-y-0"
      >
        Skip to content
      </a>
      <SiteHeader />
      <main id="main-content">
        <Hero />
        <AboutSection />
        <SkillsSection />
        <ExperienceSection />
        <ProjectsSection />
        <ContactSection />
      </main>
      <SiteFooter />
    </>
  );
}

/**
 * Honours a `#section` from a bookmark or shared link, then drops it so the
 * address bar settles on the bare domain. The jump has to happen here rather
 * than natively: the sections do not exist in the served HTML, so the browser
 * has nothing to anchor to on first paint.
 */
function useCleanUrl() {
  useEffect(() => {
    const { hash, pathname, search } = window.location;
    if (!hash) return;

    const frame = requestAnimationFrame(() => {
      scrollToSection(hash, "instant");
      window.history.replaceState(null, "", pathname + search);
    });

    return () => cancelAnimationFrame(frame);
  }, []);
}
